"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRootProjectTypeNode = getRootProjectTypeNode;
exports.getTdpProjectTypeNode = getTdpProjectTypeNode;
const tslib_1 = require("tslib");
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const fs_extra_1 = tslib_1.__importDefault(require("fs-extra"));
const os_1 = tslib_1.__importDefault(require("os"));
const path_1 = tslib_1.__importDefault(require("path"));
const globalVars_1 = require("../../../common/globalVars");
const templateHelper_1 = require("../../../component/generator/templateHelper");
const folder_1 = require("../../../folder");
const constructNode_1 = require("../constructNode");
/**
 * Load the wizard question tree from wizardNode.json.
 * Combined JSON with all sub-trees inlined.
 */
function getRootProjectTypeNode(platform = teamsfx_api_1.Platform.VSCode) {
    return loadUiNode("wizardNode.json", platform);
}
/**
 * Load the TDP wizard question tree from tdpNode.json.
 * Subset of wizard options for Teams Developer Portal import flow.
 */
function getTdpProjectTypeNode(platform = teamsfx_api_1.Platform.VSCode) {
    return loadUiNode("tdpNode.json", platform);
}
function loadUiNode(fileName, platform) {
    const cachedJsonPath = path_1.default.join(os_1.default.homedir(), `.${String(teamsfx_api_1.ConfigFolderName)}`, "ui", fileName);
    let jsonPath;
    let source;
    if (!(0, templateHelper_1.useLocalTemplate)() && fs_extra_1.default.pathExistsSync(cachedJsonPath)) {
        jsonPath = cachedJsonPath;
        source = "cache";
    }
    else {
        jsonPath = path_1.default.join((0, folder_1.getTemplatesFolder)(), "ui", fileName);
        source = "bundled";
    }
    const content = fs_extra_1.default.readFileSync(jsonPath, "utf-8");
    globalVars_1.TOOLS?.logProvider?.info(`[Dynamic Template] Loaded ${fileName} from ${source}: ${jsonPath}`);
    return (0, constructNode_1.constructNode)(content, platform);
}
//# sourceMappingURL=rootNode.js.map